<p-select [options]="options()" [ngModel]="selected()" (ngModelChange)="handleChange($event)" [optionLabel]="label()" [filter]="filter()" [filterBy]="filterFields()" [showClear]="showClear()"
    [optionValue]="optionValue()" [disabled]="disabled" class="flag-select" placeholder="{{placeholder() | translate}}" appendTo="body">
    <!-- Selected item template -->
    <ng-template #selectedItem let-option>
        @if (option) {
        <div class="flex items-center gap-2">
            @if (option.code == 'globe' || option?.flagCode?.toLowerCase() == 'globe') {
                <i class="icon globe-icon"></i>
            } @else {
                <img [src]="getOptionCode(option) | flag" class="flags-circle" alt="{{ getOptionName(option) }} flag" />
            }
            <div>@if(showCountry()){ {{option.country3Code}} } {{ getOptionName(option) }}</div>
        </div>
        }
    </ng-template>

    <!-- Dropdown item template -->
    <ng-template let-option #item>
        @if (option) {
        <div class="flex items-center gap-2">
            @if (option.code?.toLowerCase() === 'globe' || option?.flagCode?.toLowerCase() == 'globe') {
            <i class="icon globe-icon"></i>
            } @else {
            <img [src]="getOptionCode(option) | flag" class="flags-circle" alt="{{ getOptionName(option) }} flag" />
            }
            <div>@if(showCountry()){ {{option.country3Code}} } {{ getOptionName(option) }}</div>
        </div>
        }
    </ng-template>
</p-select>